import React from 'react';
import { Panel } from "react-bootstrap";
import Pagination from '@mui/material/Pagination';

const CustomPagination = ( props ) => {
  const { currentPage, handlePageChange, totalPageCount } = props;

  return (
    <Panel style={ { marginTop : "-13px", borderColor : "white", maxHeight: "105px", minHeight: "100px" } }>
      <Panel.Body>
        <div className="pagination">
          <Pagination
            count={ totalPageCount }
            variant="outlined"
            shape="rounded"
            page={ Number(currentPage) }
            onClick= { handlePageChange }
          />
        </div>
      </Panel.Body>
    </Panel>
  );
};

export default CustomPagination;
